"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = require("styled-components");

exports.sizes = {
  desktop: 992,
  phone: 576,
  tablet: 768
};
exports.default = styled_components_1.createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  body {\n    font-family: 'sofia-pro';\n    font-size: 16px;\n    color: #19232D;\n    background-color: #0046D1;\n    background-image: url('/bg.svg');\n    background-repeat: no-repeat;\n    background-size: cover;\n    margin: 0 4%;\n    height: 100vh;\n  } \n\n  * {\n    box-sizing: border-box;\n  }\n\n  #root {\n    height: 100%;\n  }\n\n  .hide-sm{\n    @media (max-width: ", "px) {\n      display: none;\n    }\n  }\n"], ["\n  body {\n    font-family: 'sofia-pro';\n    font-size: 16px;\n    color: #19232D;\n    background-color: #0046D1;\n    background-image: url('/bg.svg');\n    background-repeat: no-repeat;\n    background-size: cover;\n    margin: 0 4%;\n    height: 100vh;\n  } \n\n  * {\n    box-sizing: border-box;\n  }\n\n  #root {\n    height: 100%;\n  }\n\n  .hide-sm{\n    @media (max-width: ", "px) {\n      display: none;\n    }\n  }\n"])), exports.sizes.phone);
var templateObject_1;